// Opens the header search as a native dialog with Shopify predictive search.
// The search link stays a plain link without JavaScript or <dialog> support.
class MeriHeaderSearch extends HTMLElement {
  connectedCallback() {
    if (this.events) return;
    this.link = this.querySelector('.header-search');
    this.dialog = this.querySelector('dialog');
    if (!this.link || typeof this.dialog?.showModal !== 'function') return;
    this.events = new AbortController();
    const { signal } = this.events;
    this.link.addEventListener(
      'click',
      (event) => {
        // Modified clicks keep their native meaning (new tab, new window).
        if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.open();
      },
      { signal },
    );
    // Return focus to the search link (WebKit leaves it on the body after a modal closes).
    this.dialog.addEventListener(
      'close',
      () => {
        const active = document.activeElement;
        if (!active || active === document.body || this.dialog.contains(active)) this.link.focus();
      },
      { signal },
    );
    this.dialog.addEventListener(
      'click',
      (event) => {
        // A click on the backdrop reaches the dialog itself.
        if (event.target === this.dialog || event.target.closest('[data-header-search-close]')) this.dialog.close();
      },
      { signal },
    );
  }
  disconnectedCallback() {
    this.events?.abort();
    this.events = null;
    if (this.dialog?.open) this.dialog.close();
  }
  open() {
    // Suggestions are an enhancement; the form still submits to the search page without them.
    if (this.dataset.module) import(this.dataset.module).catch(() => {});
    this.dialog.showModal();
    this.dialog.querySelector('input[type="search"]')?.focus();
  }
}
if (!customElements.get('meri-header-search')) customElements.define('meri-header-search', MeriHeaderSearch);
